(function(){
  if (window.__cozyInit) return; window.__cozyInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function splitText(root){
    root.querySelectorAll('[data-split]:not(.cz-split)').forEach(function(el){
      var i = 0;
      (function walk(node){
        Array.prototype.slice.call(node.childNodes).forEach(function(n){
          if (n.nodeType === 3){
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function(part){
              if (!part) return;
              if (/^\s+$/.test(part)){ frag.appendChild(document.createTextNode(part)); return; }
              var w = document.createElement('span'); w.className = 'cz-word';
              var s = document.createElement('span'); s.textContent = part; s.style.setProperty('--i', i++);
              w.appendChild(s); frag.appendChild(w);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1){ walk(n); }
        });
      })(el);
      el.classList.add('cz-split');
    });
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); if (e.target.hasAttribute('data-count')) count(e.target); }
    });
  }, {threshold:.18, rootMargin:'0px 0px -40px 0px'}) : null;

  function count(el){
    var end = parseFloat(el.getAttribute('data-count')) || 0, dec = (el.getAttribute('data-count').split('.')[1]||'').length;
    var suf = el.getAttribute('data-suffix') || '', t0 = null, dur = 1600;
    if (reduce){ el.textContent = end.toFixed(dec) + suf; return; }
    function step(t){ if(!t0) t0 = t; var p = Math.min((t - t0)/dur, 1); p = 1 - Math.pow(1-p, 3);
      el.textContent = (end*p).toFixed(dec).replace('.', '.') + suf; if (p < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }

  function observe(root){
    root.querySelectorAll('[data-reveal],[data-split],[data-count]').forEach(function(el){
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  function embers(root){
    root.querySelectorAll('.cz-embers:not([data-done])').forEach(function(box){
      box.setAttribute('data-done','');
      if (reduce) return;
      for (var k=0;k<18;k++){
        var i = document.createElement('i');
        i.style.left = (Math.random()*100)+'%';
        i.style.animationDuration = (9+Math.random()*10)+'s';
        i.style.animationDelay = (-Math.random()*15)+'s';
        var s = 3+Math.random()*5; i.style.width = i.style.height = s+'px';
        box.appendChild(i);
      }
    });
  }

  function parallax(){
    if (reduce) return;
    var items = [];
    function collect(){ items = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]')); }
    collect(); document.addEventListener('shopify:section:load', collect);
    var ticking = false;
    function run(){
      var vh = window.innerHeight;
      items.forEach(function(el){
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var sp = parseFloat(el.getAttribute('data-parallax')) || .15;
        var off = (r.top + r.height/2 - vh/2) * -sp;
        el.style.transform = 'translate3d(0,'+off.toFixed(1)+'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function(){ if(!ticking){ ticking = true; requestAnimationFrame(run); } }, {passive:true});
    run();
  }

  function tilt(root){
    if (reduce || !window.matchMedia('(hover:hover)').matches) return;
    root.querySelectorAll('[data-tilt]').forEach(function(el){
      el.addEventListener('mousemove', function(e){
        var r = el.getBoundingClientRect(), x = (e.clientX - r.left)/r.width - .5, y = (e.clientY - r.top)/r.height - .5;
        el.style.transform = 'perspective(900px) rotateY('+(x*8)+'deg) rotateX('+(-y*8)+'deg)';
      });
      el.addEventListener('mouseleave', function(){ el.style.transform = ''; });
    });
    root.querySelectorAll('[data-magnet]').forEach(function(el){
      el.addEventListener('mousemove', function(e){
        var r = el.getBoundingClientRect();
        el.style.transform = 'translate('+((e.clientX-r.left-r.width/2)*.18)+'px,'+((e.clientY-r.top-r.height/2)*.3)+'px)';
      });
      el.addEventListener('mouseleave', function(){ el.style.transform = ''; });
    });
  }

  function buybox(root){
    root.querySelectorAll('[data-cz-buy]').forEach(function(form){
      if (form.__cz) return; form.__cz = true;
      var qty = form.querySelector('input[name="quantity"]');
      form.querySelectorAll('[data-qty]').forEach(function(b){
        b.addEventListener('click', function(){ var v = Math.max(1, (parseInt(qty.value,10)||1) + parseInt(b.getAttribute('data-qty'),10)); qty.value = v; });
      });
      var price = form.closest('.cz-spot') && form.closest('.cz-spot').querySelector('[data-price]');
      var cmp = form.closest('.cz-spot') && form.closest('.cz-spot').querySelector('[data-compare]');
      form.querySelectorAll('input[name="id"][type="radio"]').forEach(function(r){
        r.addEventListener('change', function(){
          if (price && r.dataset.price) price.textContent = r.dataset.price;
          if (cmp){ cmp.textContent = r.dataset.compare || ''; cmp.style.display = r.dataset.compare ? '' : 'none'; }
        });
      });
      // sticky bar
      var sticky = document.querySelector('.cz-sticky[data-for="'+form.id+'"]');
      if (sticky && io){
        var sio = new IntersectionObserver(function(en){ en.forEach(function(e){
          sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
        }); });
        sio.observe(form);
        var sb = sticky.querySelector('button');
        var primary = form.querySelector('[data-primary]');
        if (sb && primary) sb.addEventListener('click', function(){ primary.click(); });
      }
    });
  }

  function init(root){ root = root || document; splitText(root); observe(root); embers(root); tilt(root); buybox(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); parallax(); });
  else { init(); parallax(); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
